import React from 'react';

class CustomIntegerInput extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || 0
    };
  }

  bounds = () => {
    const { icon, min, max } = this.props;
    return {
      lower: min !== undefined ? min : 0,
      upper: max !== undefined ? max : icon === '%' ? 100 : undefined,
    };
  };

  clamp = (raw) => {
    const { lower, upper } = this.bounds();
    const parsed = parseInt(raw, 10);
    if (isNaN(parsed)) return lower;
    const bounded = Math.max(lower, parsed);
    return upper !== undefined ? Math.min(upper, bounded) : bounded;
  };

  handleChange = (event) => {
    this.setState({ value: event.target.value });
    if (this.props.onChange) {
      this.props.onChange(this.clamp(event.target.value));
    }
  };

  handleBlur = () => {
    this.setState({ value: this.clamp(this.state.value) });
  };

  render() {
    const { label, toolTip, icon } = this.props;
    const { lower, upper } = this.bounds();

    return (
      <div className='RT-TextBox'>
        <label>
          {label}
          {toolTip && <span className="tooltip">{toolTip}</span>}
        </label>
        <div className="input-group" style={{ width: 250, height: 35 }}>
          {icon && <span className="input-group-text">{icon}</span>}
          <input
            type="number"
            className="form-control"
            value={this.state.value}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            min={lower}
            max={upper}
          />
        </div>
      </div>
    );
  }
}

export default CustomIntegerInput;